import { useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../customAxios.js";
import {
  TableCell,
  TableRow,
  Button,
  IconButton,
  TextField,
  CircularProgress,
} from "@mui/material";
import { strDateFormat } from "../utils/functions";
import AlertBox from "./AlertBox.jsx";

function ClickAndCollectRow(props) {
  const { request, columns, color, orderTypes } = props;
  const [confirmDisabled, setConfirmDisabled] = useState(true);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [QR, setQR] = useState("");
  let navigate = useNavigate();

  const checkQR = async () => {
    setConfirmLoading(true);
    try {
      const { data } = await axios.get(`/verify_order_qr/${request.id}/${QR}/`);

      if (data.valid) {
        setConfirmDisabled(false);
        setMessageAlert("Código QR validado correctamente");
        setOpenSuccessAlert(true);
      } else {
        setMessageAlert("Código QR inválido");
        setOpenErrorAlert(true);
      }
    } catch (error) {
      setOpenErrorAlert(true);
      setMessageAlert("Error al validar el código QR");
      console.error(
        `Fallo al actualizar la orden: ${error?.response || error}`
      );
    } finally {
      setConfirmLoading(false);
    }
  };

  const handleConfirm = async () => {
    const data = { action: "complete", id: request.id };
    try {
      const { status } = await axios.put("update_order_info/", data);

      if (status === 200) {
        navigate(0);
      }
    } catch (error) {
      setOpenErrorAlert(true);
      setMessageAlert("Error al confirmar la orden");
      console.error(
        `Fallo al actualizar la orden: ${error?.response || error}`
      );
    }
  };

  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
    setOpenErrorAlert(false);
  };

  return (
    <>
      <TableRow
        sx={{ "& > *": { borderBottom: "unset" } }}
        style={{ backgroundColor: color }}
      >
        {columns.map((column, index) => {
          if (column.columnName === "Acciones") {
            return (
              <TableCell key={`action-${index}`} className="actions-container">
                <Button
                  onClick={() => handleConfirm()}
                  variant="outlined"
                  disabled={confirmDisabled}
                  className={`btn-custom mg-l-10 ${
                    confirmDisabled ? "button-disabled" : ""
                  }`}
                >
                  {confirmLoading ? (
                    <CircularProgress className="loading-btn" />
                  ) : (
                    "Entregar"
                  )}
                </Button>
              </TableCell>
            );
          } else if (column.columnName === "Validación QR") {
            return (
              <TableCell key={`action-${index}`} className="actions-cell">
                <TextField
                  placeholder="Enter code"
                  variant="outlined"
                  size="small"
                  style={{ marginTop: 0, marginBottom: 0, width: "100%" }}
                  onChange={(e) => setQR(e.target.value)}
                  value={QR}
                  // Add onChange and value props as needed for handling input
                />

                <IconButton onClick={() => checkQR()}>
                  <i className="material-icons">check_circle</i>
                </IconButton>
              </TableCell>
            );
          } else {
            return (
              <TableCell
                component="th"
                scope="row"
                key={`${column.columnName}-${index}`}
              >
                {column.dbName === "id" ? (
                  request.reference_id
                ) : column.dbName === "id_goex" ? (
                  request.id
                ) : column.dbName === "seller_company_social_reason" ? (
                  request.seller?.company.social_reason
                ) : column.dbName === "recipient" ? (
                  request.recipient
                ) : column.dbName === "creation_date" ? (
                  request.created_at &&
                  strDateFormat(new Date(request.created_at))
                ) : column.dbName === "details" ? (
                  <IconButton
                    onClick={() =>
                      navigate(`/home/order-details/${request.id}`)
                    }
                  >
                    <i className="material-icons">add</i>{" "}
                  </IconButton>
                ) : (
                  "COLUMNA DESCONOCIDA"
                )}
              </TableCell>
            );
          }
        })}
      </TableRow>
      <AlertBox
        severity="success"
        messageAlert={messageAlert}
        setOpenAlert={setOpenSuccessAlert}
        openAlert={openSuccessAlert}
        hideDuration={6000}
      />
      <AlertBox
        severity="error"
        messageAlert={messageAlert}
        setOpenAlert={setOpenErrorAlert}
        openAlert={openErrorAlert}
        hideDuration={6000}
      />
    </>
  );
}

export default ClickAndCollectRow;
